import type { TrackingAdapter } from '../tracking-adapter';

/**
 * Adapter that does nothing
 * Useful for testing or when tracking is disabled
 */
export class NoopTrackingAdapter implements TrackingAdapter {
  track(_event: string, _properties?: Record<string, unknown>): void {
    // No-op
  }

  identify(_userId: string, _companyId: string, _properties?: Record<string, unknown>): void {
    // No-op
  }

  pageView(_page: string, _properties?: Record<string, unknown>): void {
    // No-op
  }

  reset(): void {
    // No-op
  }

  getSessionId(): string | null {
    return null;
  }

  getSessionIdHeader(): string {
    return '';
  }
}
